// removed by extract-text-webpack-plugin
module.exports = {"picklist-table":"index__picklist-table___vMPYn"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ui/DraggableTable/index.less
// module id = 493
// module chunks = 3